import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Slider,
  Checkbox,
  Radio,
  TextField,
  Stack,
} from "@vapor/react-material";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { useTranslation } from "react-i18next";
import VaporTag from "@vapor/react-custom/VaporTag";

export const RischioSectionB = ({
  tenantTypeId,
  sliderVal,
  chbVal,
  textNotes,
  selectedRadioValues,
  currentRischio,
  subTotaleB,
  isUserAllowedToManage,
  onSliderChange,
  onCheckboxChange,
  onRadioChange,
  onTableRowClick,
  sliderLivelli,
  sliderLivelliAvv,
  rischioPaesePrest,
  rischioProvinciaPrest,
  showTabellaB = true,
}) => {
  const { t } = useTranslation();

  if (!showTabellaB) return null;

  // Helper function to get text note value
  const getTextNoteValue = (sectionId) => {
    const noteKey = `txtAltro${sectionId}`;
    return textNotes?.[noteKey] || "";
  };

  const renderTableBContent = () => {
    const sections = [
      {
        id: "B1",
        title: tenantTypeId === 3 ? "B.1 - Tipologia" : t("valutazione.form.tabellaB.b1"),
        sliderName: "sliderB1",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB1_1", label: t("valutazione.form.tabellaB.b1_1") },
          { id: "chbB1_2", label: t("valutazione.form.tabellaB.b1_2") },
          { id: "chbB1_3", label: t("valutazione.form.tabellaB.b1_3") },
          { id: "chbB1_4", label: "Operazioni relative a petrolio, armi, metalli preziosi, prodotti del tabacco, manufatti culturali e altri beni mobili di importanza archeologica, storica, culturale e religiosa o di raro valore scientifico, nonché avorio e specie protette" },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB1_1", label: "Operazione di compravendita" },
          { id: "chbB1_2", label: "Consulenza" },
          { id: "chbB1_3", label: "Due diligence" },
        ] : null,
        altroField: "chbB1_Altro",
        altroNote: currentRischio?.sp_b1_altro_note,
        altroText: t("valutazione.form.tabellaB.b1_4"),
      },
      {
        id: "B2",
        title: tenantTypeId === 3 ? "B.2 - Valore dell'operazione" : t("valutazione.form.tabellaB.b2"),
        sliderName: "sliderB2",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB2_1", label: t("valutazione.form.tabellaB.b2_1") },
          { id: "chbB2_2", label: t("valutazione.form.tabellaB.b2_2") },
          { id: "chbB2_3", label: t("valutazione.form.tabellaB.b2_3") },
          { id: "chbB2_4", label: t("valutazione.form.tabellaB.b2_4") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB2_1", label: "Inferiore a € 25.000" },
          { id: "chbB2_2", label: "Da € 25.000 a € 100.000" },
          { id: "chbB2_3", label: "Da € 100.000 a € 500.000" },
          { id: "chbB2_4", label: "Superiore a € 500.000" },
        ] : null,
        altroField: "chbB2_Altro",
        altroNote: currentRischio?.sp_b2_altro_note,
        altroText: tenantTypeId === 3 ? "Altro" : t("valutazione.form.tabellaB.b2_5"),
      },
      {
        id: "B3",
        title: tenantTypeId === 3 ? "B.3 - Modalità di svolgimento" : t("valutazione.form.tabellaB.b3"),
        sliderName: "sliderB3",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB3_1", label: t("valutazione.form.tabellaB.b3_1") },
          { id: "chbB3_2", label: t("valutazione.form.tabellaB.b3_2") },          
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB3_1", label: "Presenza fisica del cliente" },
          { id: "chbB3_2", label: "Per via telematica" },
        ] : null,
        altroField: "chbB3_Altro",
        altroNote: currentRischio?.sp_b3_altro_note,
        altroText: "Altro",
      },
      {
        id: "B4",
        title: tenantTypeId === 3 ? "B.4 - Frequenza e durata" : "B.4 - Frequenza e volume delle operazioni",
        sliderName: "sliderB4",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB4_1", label: t("valutazione.form.tabellaB.b4_1") },
          { id: "chbB4_2", label: t("valutazione.form.tabellaB.b4_2") },          
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB4_1", label: "Operazione occasionale" },
          { id: "chbB4_2", label: "Operazione ricorrente" },
        ] : null,
        altroField: "chbB4_Altro",
        altroNote: currentRischio?.sp_b4_altro_note,
        altroText: "Altro",
      },
      {
        id: "B5",
        title: tenantTypeId === 3 ? "B.5 - Area geografica" : (tenantTypeId === 2 ? "B.5 - Durata della prestazione professionale" : t("valutazione.form.tabellaB.b5")),
        sliderName: "sliderB5",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB5_1", label: t("valutazione.form.tabellaB.b5_1") },
          { id: "chbB5_2", label: t("valutazione.form.tabellaB.b5_2") },
          { id: "chbB5_3", label: t("valutazione.form.tabellaB.b5_3") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB5_1", label: "Italia" },
          { id: "chbB5_2", label: "Paesi UE" },
          { id: "chbB5_3", label: "Paesi extra UE" },
          { id: "chbB5_4", label: "Territori off shore" },
        ] : null,
        altroField: "chbB5_Altro",
        altroNote: currentRischio?.sp_b5_altro_note,
        altroText: "Altro",
        showGeographicInfo: tenantTypeId === 3,
      },
      {
        id: "B6",
        title: tenantTypeId === 3 ? "B.6 - Soggetti coinvolti" : (tenantTypeId === 2 ? "B.6 - Ragionevolezza" : t("valutazione.form.tabellaB.b6")),
        sliderName: "sliderB6",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbB6_1", label: t("valutazione.form.tabellaB.b6_1") },
          { id: "chbB6_2", label: t("valutazione.form.tabellaB.b6_2") },
          { id: "chbB6_3", label: t("valutazione.form.tabellaB.b6_3") },          
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbB6_1", label: "Pubbliche amministrazioni" },
          { id: "chbB6_2", label: "Enti o associazioni di diritto privato" },
          { id: "chbB6_3", label: "Banche" },
          { id: "chbB6_4", label: "Società finanziarie" },
        ] : null,
        altroField: "chbB6_Altro",
        altroNote: currentRischio?.sp_b6_altro_note,
        altroText: "Altro",
        showGeographicInfo: tenantTypeId !== 2 && tenantTypeId !== 3,
      },
    ];

    // Aggiunta sezione B7 solo per Consulenti del Lavoro (tenantTypeId === 2)
    if (tenantTypeId === 2) {
      sections.push({
        id: "B7",
        title: "B.7 - Area geografica di destinazione",
        sliderName: "sliderB7",
        checkboxes: null,
        radios: null,
        altroField: null,
        altroNote: null,
        altroText: null,
        showGeographicInfo: true,
      });
    }

    return sections.map((section) => (
      <React.Fragment key={section.id}>
        {/* Section Header with Slider */}
        <TableRow>
          <TableCell colSpan={2}>
            <ExtendedTypography
              variant="subtitle2"
              fontStyle={
                tenantTypeId === 1 || tenantTypeId === 3
                  ? { fontWeight: "bold" }
                  : null
              }
            >
              {section.title}
            </ExtendedTypography>
            {section.showGeographicInfo && (
              <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                {rischioPaesePrest.paese !== "Italia" ? (
                  <VaporTag
                    variant="standard"
                    label={
                      rischioPaesePrest.paese +
                      " - " +
                      rischioPaesePrest.rischio +
                      " (" +
                      rischioPaesePrest.value +
                      ")"
                    }
                    sx={{
                      ...rischioPaesePrest.color,
                      mr: 1,
                    }}
                  />
                ) : null}

                {rischioPaesePrest.paese === "Italia" && rischioProvinciaPrest.found ? (
                  <VaporTag
                    variant="standard"
                    label={
                      rischioProvinciaPrest.provincia +
                      " - " +
                      rischioProvinciaPrest.rischio +
                      " (" +
                      rischioProvinciaPrest.value +
                      ")"
                    }
                    sx={rischioProvinciaPrest.color}
                  />
                ) : null}
              </Stack>
            )}
          </TableCell>
          <TableCell align="center" colSpan={1}>
            <Slider
              id={section.sliderName}
              name={section.sliderName}
              step={1}
              marks={tenantTypeId === 3 ? sliderLivelliAvv : sliderLivelli}
              min={1}
              max={tenantTypeId === 3 ? 5 : 4}
              valueLabelDisplay="auto"
              value={sliderVal[section.sliderName]}
              onChange={onSliderChange}
              disabled={!isUserAllowedToManage}
            />
          </TableCell>
        </TableRow>

        {/* Checkboxes for tenant type 1 */}
        {section.checkboxes && section.checkboxes.map((checkbox) => (
          <TableRow
            key={checkbox.id}
            hover
            onClick={() => onTableRowClick(checkbox.id)}
            sx={{ cursor: "pointer" }}
          >
            <TableCell align="left" width="70%">
              {checkbox.label}
            </TableCell>
            <TableCell align="center" width="15%">
              <Checkbox
                id={checkbox.id}
                checked={chbVal[checkbox.id]}
                onChange={onCheckboxChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
        ))}

        {/* Radio buttons for tenant type 3 */}
        {section.radios && section.radios.map((radio) => (
          <TableRow
            key={radio.id}
            hover
            onClick={() => onRadioChange(radio.id, section.id)}
            sx={{ cursor: "pointer" }}
          >
            <TableCell align="left" width="70%">
              {radio.label}
            </TableCell>
            <TableCell align="center" width="15%">
              <Radio
                checked={selectedRadioValues[section.id] === radio.id}
                id={radio.id}
                value={radio.id}
                name={`radio-${section.id}`}
                inputProps={{ 'aria-label': radio.id }}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
        ))}

        {/* Altro field - Condizioni specifiche per ogni sezione */}
        {section.altroField && (
          ((tenantTypeId === 1) || 
           (tenantTypeId === 3 && (section.id === "B1" || section.id === "B2"))) && (
          <TableRow hover>
            <TableCell align="left" width="70%">
              <Stack direction="column" spacing={1}>
                <ExtendedTypography variant="subtitle2">
                  {section.altroText}
                </ExtendedTypography>
                <TextField
                  id={`txtAltro${section.id}`}
                  key={`txtAltro${section.id}`}
                  label=""
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                  sx={
                    chbVal[section.altroField]
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  value={getTextNoteValue(section.id)}
                  onChange={(event) => {
                    // Chiama onCheckboxChange con un evento personalizzato per il campo di testo
                    const customEvent = {
                      target: {
                        id: `txtAltro${section.id}`,
                        value: event.target.value,
                        type: 'text'
                      }
                    };
                    onCheckboxChange(customEvent);
                  }}
                  inputProps={{ autocomplete: "nope", maxLength: 1000 }}
                  disabled={!isUserAllowedToManage}
                />
              </Stack>
            </TableCell>
            <TableCell align="center" width="15%">
              <Checkbox
                id={section.altroField}
                checked={chbVal[section.altroField]}
                onChange={onCheckboxChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
          )
        )}
      </React.Fragment>
    ));
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left" width="70%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.tabellaB.titolo")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.fattoreRischioRiscontrato")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.livelloRischioSpecifico")}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderTableBContent()}
          
          {/* Subtotal Row */}
          <TableRow sx={{ backgroundColor: "hsl(199, 100%, 40%)" }}>
            <TableCell colSpan="2" align="right" width="85%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {t("rischio.rischioForm.perfSpRsk")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {subTotaleB}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
